// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var $$Array = require("rescript/lib/js/array.js");
var Curry = require("rescript/lib/js/curry.js");
var React = require("react");
var Js_dict = require("rescript/lib/js/js_dict.js");
var Js_json = require("rescript/lib/js/js_json.js");
var Belt_Int = require("rescript/lib/js/belt_Int.js");
var Belt_List = require("rescript/lib/js/belt_List.js");
var Belt_Array = require("rescript/lib/js/belt_Array.js");
var Belt_Option = require("rescript/lib/js/belt_Option.js");
var Json_decode = require("@glennsl/bs-json/src/Json_decode.res.js");
var JsxRuntime = require("react/jsx-runtime");
var Nps$ReactHooksTemplate = require("./Nps.res.js");
var Utils$ReactHooksTemplate = require("../common/utils.res.js");
var NpsLabel$ReactHooksTemplate = require("./NpsLabel.res.js");
var ToggleInput$ReactHooksTemplate = require("../common/ToggleInput.res.js");
var ToggleMandatory$ReactHooksTemplate = require("./ToggleMandatory.res.js");
var NpsRepresentationConfig$ReactHooksTemplate = require("./NpsRepresentationConfig.res.js");

function getCurrentComponentType(nps) {
  return Belt_Option.getWithDefault(Nps$ReactHooksTemplate.componentType(nps), "rounded_box_with_smiley");
}

function decodeConfigItems(config) {
  if (config === undefined) {
    return Belt_List.toArray(/* [] */0);
  }
  var d = Js_json.decodeObject(config);
  if (d === undefined) {
    return Belt_List.toArray(/* [] */0);
  }
  var itemsJson = Js_dict.get(d, "items");
  if (itemsJson === undefined) {
    return Belt_List.toArray(/* [] */0);
  }
  var arr = Js_json.decodeArray(itemsJson);
  if (arr !== undefined) {
    return Belt_Array.map(arr, (function (item) {
                  var decOptStr = function (param) {
                    return Json_decode.optional((function (param) {
                                  return Json_decode.field("content", Json_decode.string, param);
                                }), param);
                  };
                  var oc = Belt_Option.getWithDefault(decOptStr(item), "");
                  var ou = Belt_Option.getWithDefault(Json_decode.optional((function (param) {
                              return Json_decode.field("url", Json_decode.string, param);
                            }), item), "");
                  var oi = Belt_Option.getWithDefault(Json_decode.optional((function (param) {
                              return Json_decode.field("inline", Json_decode.string, param);
                            }), item), "");
                  var ocolor = Belt_Option.getWithDefault(Json_decode.optional((function (param) {
                              return Json_decode.field("color", Json_decode.string, param);
                            }), item), "");
                  var v = Json_decode.field("value", Json_decode.$$int, item);
                  return {
                          value: v,
                          content: oc,
                          url: ou,
                          inline: oi,
                          color: ocolor
                        };
                }));
  } else {
    return Belt_List.toArray(/* [] */0);
  }
}

function getVisualType(config) {
  if (config === undefined) {
    return "number";
  }
  var d = Js_json.decodeObject(config);
  if (d === undefined) {
    return "number";
  }
  var vt = Js_dict.get(d, "visualType");
  if (vt !== undefined) {
    return Belt_Option.getWithDefault(Js_json.decodeString(vt), "number");
  } else {
    return "number";
  }
}

function normalizeConfiguration(config) {
  if (config === undefined) {
    return ;
  }
  var match = Js_json.decodeObject(config);
  if (match !== undefined) {
    return config;
  }
  var s = Js_json.decodeString(config);
  if (s === undefined) {
    return ;
  }
  try {
    var parsed = JSON.parse(s);
    var match$1 = Js_json.decodeObject(parsed);
    if (match$1 !== undefined) {
      return parsed;
    } else {
      return ;
    }
  }
  catch (exn){
    return ;
  }
}

function NpsEditor(props) {
  var onNpsChange = props.onNpsChange;
  var nps = props.nps;
  var leftCount = NpsLabel$ReactHooksTemplate.left(Nps$ReactHooksTemplate.label(nps)).length;
  var rightCount = NpsLabel$ReactHooksTemplate.right(Nps$ReactHooksTemplate.label(nps)).length;
  var currentComponentType = Belt_Option.getWithDefault(Nps$ReactHooksTemplate.componentType(nps), "rounded_box_with_smiley");
  var currentVisualType = getVisualType(Nps$ReactHooksTemplate.configuration(nps));
  var scaleString = NpsRepresentationConfig$ReactHooksTemplate.scaleStringFromNps(Nps$ReactHooksTemplate.scale(nps), Nps$ReactHooksTemplate.includeZero(nps));
  var configForInit = normalizeConfiguration(Nps$ReactHooksTemplate.configuration(nps));
  var match = React.useState(function (param) {
        var existing = decodeConfigItems(configForInit);
        if (existing.length !== 0) {
          return existing;
        } else {
          return NpsRepresentationConfig$ReactHooksTemplate.defaultItemsForScaleAndType(scaleString, currentVisualType);
        }
      });
  var setCustomItems = match[1];
  var customItems = match[0];
  var match$1 = React.useState(function (param) {
        return NpsRepresentationConfig$ReactHooksTemplate.getCategoryRangesFromConfig(configForInit, scaleString);
      });
  var setCategoryRanges = match$1[1];
  var categoryRanges = match$1[0];
  var match$2 = React.useState(function (param) {
        return NpsRepresentationConfig$ReactHooksTemplate.getCategoryColorsFromConfig(configForInit);
      });
  var setCategoryColors = match$2[1];
  var categoryColors = match$2[0];
  var match$3 = React.useState(function (param) {
        
      });
  var setCategoryRangeError = match$3[1];
  var categoryRangeError = match$3[0];
  var match$4 = React.useState(function (param) {
        
      });
  var setPendingRangeEdit = match$4[1];
  var pendingRangeEdit = match$4[0];
  var skipFirstItemsEffect = React.useRef(true);
  React.useEffect((function (param) {
          if (skipFirstItemsEffect.current) {
            skipFirstItemsEffect.current = false;
            return ;
          }
          var newItems = NpsRepresentationConfig$ReactHooksTemplate.defaultItemsForScaleAndType(scaleString, currentVisualType);
          Curry._1(setCustomItems, (function (param) {
                  return newItems;
                }));
        }), [
        scaleString,
        currentVisualType
      ]);
  var onLabelChange = function (f, $$event) {
    var formTargetValue = Utils$ReactHooksTemplate.formTargetValue($$event);
    if (Utils$ReactHooksTemplate.checkMaxLength24(formTargetValue)) {
      return Curry._1(onNpsChange, Nps$ReactHooksTemplate.setLabel(nps, Curry._2(f, Nps$ReactHooksTemplate.label(nps), formTargetValue)));
    }
    
  };
  var baseConfigForCategories = function (param) {
    if (currentComponentType === "custom") {
      return NpsRepresentationConfig$ReactHooksTemplate.buildCustomConfig(currentVisualType, customItems);
    }
    
  };
  var rangeInputDisplayValue = function (cat, field) {
    if (pendingRangeEdit !== undefined && pendingRangeEdit[0] === cat && pendingRangeEdit[1] === field) {
      return pendingRangeEdit[2];
    }
    switch (cat) {
      case "detractor" :
          switch (field) {
            case "max" :
                return String(categoryRanges.detractor.max);
            case "min" :
                return String(categoryRanges.detractor.min);
            default:
              return "";
          }
      case "passive" :
          switch (field) {
            case "max" :
                return String(categoryRanges.passive.max);
            case "min" :
                return String(categoryRanges.passive.min);
            default:
              return "";
          }
      case "promoter" :
          switch (field) {
            case "max" :
                return String(categoryRanges.promoter.max);
            case "min" :
                return String(categoryRanges.promoter.min);
            default:
              return "";
          }
      default:
        return "";
    }
  };
  var handleRangeInputChange = function (cat, field, valueStr) {
    var v = Belt_Int.fromString(valueStr);
    if (v !== undefined) {
      Curry._1(setPendingRangeEdit, (function (param) {
              
            }));
      var update = function (r) {
        switch (cat) {
          case "detractor" :
              switch (field) {
                case "max" :
                    var init = r.detractor;
                    return {
                            detractor: {
                              min: init.min,
                              max: v
                            },
                            passive: r.passive,
                            promoter: r.promoter
                          };
                case "min" :
                    var init$1 = r.detractor;
                    return {
                            detractor: {
                              min: v,
                              max: init$1.max
                            },
                            passive: r.passive,
                            promoter: r.promoter
                          };
                default:
                  return r;
              }
          case "passive" :
              switch (field) {
                case "max" :
                    var init$2 = r.passive;
                    return {
                            detractor: r.detractor,
                            passive: {
                              min: init$2.min,
                              max: v
                            },
                            promoter: r.promoter
                          };
                case "min" :
                    var init$3 = r.passive;
                    return {
                            detractor: r.detractor,
                            passive: {
                              min: v,
                              max: init$3.max
                            },
                            promoter: r.promoter
                          };
                default:
                  return r;
              }
          case "promoter" :
              switch (field) {
                case "max" :
                    var init$4 = r.promoter;
                    return {
                            detractor: r.detractor,
                            passive: r.passive,
                            promoter: {
                              min: init$4.min,
                              max: v
                            }
                          };
                case "min" :
                    var init$5 = r.promoter;
                    return {
                            detractor: r.detractor,
                            passive: r.passive,
                            promoter: {
                              min: v,
                              max: init$5.max
                            }
                          };
                default:
                  return r;
              }
          default:
            return r;
        }
      };
      var newRanges = update(categoryRanges);
      Curry._1(setCategoryRanges, (function (param) {
              return newRanges;
            }));
      var err = NpsRepresentationConfig$ReactHooksTemplate.validateCategoryRanges(scaleString, newRanges);
      if (err !== undefined) {
        return Curry._1(setCategoryRangeError, (function (param) {
                      return err;
                    }));
      }
      Curry._1(setCategoryRangeError, (function (param) {
              
            }));
      var merged = NpsRepresentationConfig$ReactHooksTemplate.mergeCategoryIntoConfig(baseConfigForCategories(), newRanges, categoryColors);
      return Curry._1(onNpsChange, Nps$ReactHooksTemplate.setConfiguration(nps, merged));
    } else {
      return Curry._1(setPendingRangeEdit, (function (param) {
                    return [
                            cat,
                            field,
                            valueStr
                          ];
                  }));
    }
  };
  var updateCategoryColor = function (cat, color) {
    var newColors;
    switch (cat) {
      case "detractor" :
          newColors = {
            detractor: color,
            passive: categoryColors.passive,
            promoter: categoryColors.promoter
          };
          break;
      case "passive" :
          newColors = {
            detractor: categoryColors.detractor,
            passive: color,
            promoter: categoryColors.promoter
          };
          break;
      case "promoter" :
          newColors = {
            detractor: categoryColors.detractor,
            passive: categoryColors.passive,
            promoter: color
          };
          break;
      default:
        newColors = categoryColors;
    }
    Curry._1(setCategoryColors, (function (param) {
            return newColors;
          }));
    var merged = NpsRepresentationConfig$ReactHooksTemplate.mergeCategoryIntoConfig(baseConfigForCategories(), categoryRanges, newColors);
    Curry._1(onNpsChange, Nps$ReactHooksTemplate.setConfiguration(nps, merged));
  };
  var updateCustomItem = function (index, field, value) {
    var arr = customItems.slice(0);
    var item = Belt_Array.getExn(arr, index);
    var updated;
    switch (field) {
      case "color" :
          updated = {
            value: item.value,
            content: item.content,
            url: item.url,
            inline: item.inline,
            color: value
          };
          break;
      case "content" :
          updated = {
            value: item.value,
            content: value,
            url: item.url,
            inline: item.inline,
            color: item.color
          };
          break;
      case "inline" :
          updated = {
            value: item.value,
            content: item.content,
            url: item.url,
            inline: value,
            color: item.color
          };
          break;
      case "url" :
          updated = {
            value: item.value,
            content: item.content,
            url: value,
            inline: item.inline,
            color: item.color
          };
          break;
      default:
        updated = item;
    }
    Belt_Array.set(arr, index, updated);
    Curry._1(setCustomItems, (function (param) {
            return arr;
          }));
    var visualType = getVisualType(Nps$ReactHooksTemplate.configuration(nps));
    var config = NpsRepresentationConfig$ReactHooksTemplate.buildCustomConfig(visualType, arr);
    Curry._1(onNpsChange, Nps$ReactHooksTemplate.setConfiguration(nps, NpsRepresentationConfig$ReactHooksTemplate.mergeCategoryIntoConfig(config, categoryRanges, categoryColors)));
  };
  var match$5 = Nps$ReactHooksTemplate.scale(nps);
  var tmp;
  tmp = match$5 === "FiveScale" ? true : false;
  return JsxRuntime.jsxs("div", {
              children: [
                JsxRuntime.jsx("div", {
                      children: JsxRuntime.jsx("div", {
                            children: JsxRuntime.jsxs("div", {
                                  children: [
                                    JsxRuntime.jsx("div", {
                                          children: "Start From Zero",
                                          className: "text-darkcharcoal text-sm font-medium"
                                        }),
                                    JsxRuntime.jsx(ToggleInput$ReactHooksTemplate.make, {
                                          checked: Nps$ReactHooksTemplate.includeZero(nps),
                                          handleChange: (function (param) {
                                              !Nps$ReactHooksTemplate.includeZero(nps);
                                              Curry._1(setPendingRangeEdit, (function (param) {
                                                      
                                                    }));
                                              var newIncludeZero = !Nps$ReactHooksTemplate.includeZero(nps);
                                              var updatedNps = Nps$ReactHooksTemplate.setIncludeZero(nps, newIncludeZero);
                                              var newScaleString = NpsRepresentationConfig$ReactHooksTemplate.scaleStringFromNps(Nps$ReactHooksTemplate.scale(nps), newIncludeZero);
                                              var newRanges = NpsRepresentationConfig$ReactHooksTemplate.defaultCategoryRanges(newScaleString);
                                              Curry._1(setCategoryRanges, (function (param) {
                                                      return newRanges;
                                                    }));
                                              var tmp;
                                              if (currentComponentType === "custom") {
                                                var newItems = NpsRepresentationConfig$ReactHooksTemplate.defaultItemsForScaleAndType(newScaleString, currentVisualType);
                                                Curry._1(setCustomItems, (function (param) {
                                                        return newItems;
                                                      }));
                                                var config = NpsRepresentationConfig$ReactHooksTemplate.buildCustomConfig(currentVisualType, newItems);
                                                tmp = Nps$ReactHooksTemplate.setConfiguration(updatedNps, NpsRepresentationConfig$ReactHooksTemplate.mergeCategoryIntoConfig(config, newRanges, categoryColors));
                                              } else {
                                                tmp = Nps$ReactHooksTemplate.setConfiguration(updatedNps, NpsRepresentationConfig$ReactHooksTemplate.mergeCategoryIntoConfig(undefined, newRanges, categoryColors));
                                              }
                                              Curry._1(onNpsChange, tmp);
                                            }),
                                          labelClassName: "flex items-center"
                                        })
                                  ],
                                  className: "flex justify-between"
                                }),
                            className: "mb-4 pb-4 border-b border-gray-300"
                          })
                    }),
                JsxRuntime.jsx("div", {
                      children: JsxRuntime.jsx("div", {
                            children: JsxRuntime.jsxs("div", {
                                  children: [
                                    JsxRuntime.jsx("div", {
                                          children: "5 Scale Rating",
                                          className: "text-darkcharcoal text-sm font-medium"
                                        }),
                                    JsxRuntime.jsx(ToggleInput$ReactHooksTemplate.make, {
                                          checked: tmp,
                                          handleChange: (function (param) {
                                              Curry._1(setPendingRangeEdit, (function (param) {
                                                      
                                                    }));
                                              var match = Nps$ReactHooksTemplate.scale(nps);
                                              var newScale;
                                              newScale = match === "FiveScale" ? "TenScale" : "FiveScale";
                                              var updatedNps = Nps$ReactHooksTemplate.setScale(nps, newScale);
                                              var newScaleString = NpsRepresentationConfig$ReactHooksTemplate.scaleStringFromNps(newScale, Nps$ReactHooksTemplate.includeZero(nps));
                                              var newRanges = NpsRepresentationConfig$ReactHooksTemplate.defaultCategoryRanges(newScaleString);
                                              Curry._1(setCategoryRanges, (function (param) {
                                                      return newRanges;
                                                    }));
                                              var tmp;
                                              if (currentComponentType === "custom") {
                                                var newItems = NpsRepresentationConfig$ReactHooksTemplate.defaultItemsForScaleAndType(newScaleString, currentVisualType);
                                                Curry._1(setCustomItems, (function (param) {
                                                        return newItems;
                                                      }));
                                                var config = NpsRepresentationConfig$ReactHooksTemplate.buildCustomConfig(currentVisualType, newItems);
                                                tmp = Nps$ReactHooksTemplate.setConfiguration(updatedNps, NpsRepresentationConfig$ReactHooksTemplate.mergeCategoryIntoConfig(config, newRanges, categoryColors));
                                              } else {
                                                tmp = Nps$ReactHooksTemplate.setConfiguration(updatedNps, NpsRepresentationConfig$ReactHooksTemplate.mergeCategoryIntoConfig(undefined, newRanges, categoryColors));
                                              }
                                              Curry._1(onNpsChange, tmp);
                                            }),
                                          labelClassName: "flex items-center"
                                        })
                                  ],
                                  className: "flex justify-between"
                                }),
                            className: "mb-4 pb-4 border-b border-gray-300"
                          })
                    }),
                JsxRuntime.jsx(ToggleMandatory$ReactHooksTemplate.make, {
                      mandatory: props.mandatory,
                      onMandatoryChange: props.onMandatoryChange
                    }),
                JsxRuntime.jsxs("div", {
                      children: [
                        JsxRuntime.jsxs("div", {
                              children: [
                                JsxRuntime.jsxs("div", {
                                      children: [
                                        "Left Label",
                                        JsxRuntime.jsx("p", {
                                              children: String(leftCount) + (" / " + String(24)),
                                              className: "text-gray-500 text-xs p-1 flex justify-end"
                                            })
                                      ],
                                      className: "text-darkcharcoal text-sm mb-2 font-medium flex justify-between"
                                    }),
                                JsxRuntime.jsx("input", {
                                      className: "h-40-px py-2 px-4 rounded bg-white border border-gray-300 focus:border-gray-600 text-xs w-full",
                                      placeholder: "Enter Left Label",
                                      type: "text",
                                      value: NpsLabel$ReactHooksTemplate.left(Nps$ReactHooksTemplate.label(nps)),
                                      onChange: (function (param) {
                                          return onLabelChange(NpsLabel$ReactHooksTemplate.setLeft, param);
                                        })
                                    })
                              ],
                              className: "mb-4"
                            }),
                        JsxRuntime.jsxs("div", {
                              children: [
                                JsxRuntime.jsxs("div", {
                                      children: [
                                        "Right Label",
                                        JsxRuntime.jsx("p", {
                                              children: String(rightCount) + (" / " + String(24)),
                                              className: "text-gray-500 text-xs p-1 flex justify-end"
                                            })
                                      ],
                                      className: "text-darkcharcoal text-sm mb-2 font-medium flex justify-between"
                                    }),
                                JsxRuntime.jsx("input", {
                                      className: "h-40-px py-2 px-4 rounded bg-white border border-gray-300 focus:border-gray-600 text-xs w-full",
                                      placeholder: "Enter Right Label",
                                      type: "text",
                                      value: NpsLabel$ReactHooksTemplate.right(Nps$ReactHooksTemplate.label(nps)),
                                      onChange: (function (param) {
                                          return onLabelChange(NpsLabel$ReactHooksTemplate.setRight, param);
                                        })
                                    })
                              ],
                              className: "mb-4"
                            })
                      ],
                      className: "sb-editor-two-col"
                    }),
                JsxRuntime.jsxs("div", {
                      children: [
                        JsxRuntime.jsx("div", {
                              children: "Category ranges (reporting & star colors)",
                              className: "text-darkcharcoal text-sm mb-2 font-medium"
                            }),
                        JsxRuntime.jsx("p", {
                              children: "Define which steps belong to Detractor, Passive, and Promoter. Ranges must not overlap and must cover the full scale.",
                              className: "text-spanishgray text-xs mb-2"
                            }),
                        categoryRangeError !== undefined ? JsxRuntime.jsx("p", {
                                children: categoryRangeError,
                                className: "text-red-600 text-xs mb-2"
                              }) : null,
                        JsxRuntime.jsxs("div", {
                              children: [
                                JsxRuntime.jsxs("div", {
                                      children: [
                                        JsxRuntime.jsx("span", {
                                              children: "Detractor",
                                              className: "sb-nps-range-label font-medium"
                                            }),
                                        JsxRuntime.jsx("input", {
                                              className: "w-14 border border-gray-300 rounded px-2 py-1 text-xs",
                                              max: String(NpsRepresentationConfig$ReactHooksTemplate.endValue(scaleString)),
                                              min: String(NpsRepresentationConfig$ReactHooksTemplate.startValue(scaleString)),
                                              type: "number",
                                              value: rangeInputDisplayValue("detractor", "min"),
                                              onBlur: (function (param) {
                                                  Curry._1(setPendingRangeEdit, (function (param) {
                                                          
                                                        }));
                                                }),
                                              onChange: (function (e) {
                                                  handleRangeInputChange("detractor", "min", e.target.value);
                                                })
                                            }),
                                        JsxRuntime.jsx("span", {
                                              children: "to"
                                            }),
                                        JsxRuntime.jsx("input", {
                                              className: "w-14 border border-gray-300 rounded px-2 py-1 text-xs",
                                              max: String(NpsRepresentationConfig$ReactHooksTemplate.endValue(scaleString)),
                                              min: String(NpsRepresentationConfig$ReactHooksTemplate.startValue(scaleString)),
                                              type: "number",
                                              value: rangeInputDisplayValue("detractor", "max"),
                                              onBlur: (function (param) {
                                                  Curry._1(setPendingRangeEdit, (function (param) {
                                                          
                                                        }));
                                                }),
                                              onChange: (function (e) {
                                                  handleRangeInputChange("detractor", "max", e.target.value);
                                                })
                                            }),
                                        JsxRuntime.jsx("select", {
                                              children: $$Array.of_list(Belt_List.map(NpsRepresentationConfig$ReactHooksTemplate.colorOptions, (function (param) {
                                                          var val_ = param[0];
                                                          return JsxRuntime.jsx("option", {
                                                                      children: param[1],
                                                                      value: val_
                                                                    }, val_);
                                                        }))),
                                              className: "border border-gray-300 rounded px-2 py-1 text-xs",
                                              value: categoryColors.detractor,
                                              onChange: (function (e) {
                                                  updateCategoryColor("detractor", e.target.value);
                                                })
                                            })
                                      ],
                                      className: "sb-nps-range-row"
                                    }),
                                JsxRuntime.jsxs("div", {
                                      children: [
                                        JsxRuntime.jsx("span", {
                                              children: "Passive",
                                              className: "sb-nps-range-label font-medium"
                                            }),
                                        JsxRuntime.jsx("input", {
                                              className: "w-14 border border-gray-300 rounded px-2 py-1 text-xs",
                                              max: String(NpsRepresentationConfig$ReactHooksTemplate.endValue(scaleString)),
                                              min: String(NpsRepresentationConfig$ReactHooksTemplate.startValue(scaleString)),
                                              type: "number",
                                              value: rangeInputDisplayValue("passive", "min"),
                                              onBlur: (function (param) {
                                                  Curry._1(setPendingRangeEdit, (function (param) {
                                                          
                                                        }));
                                                }),
                                              onChange: (function (e) {
                                                  handleRangeInputChange("passive", "min", e.target.value);
                                                })
                                            }),
                                        JsxRuntime.jsx("span", {
                                              children: "to"
                                            }),
                                        JsxRuntime.jsx("input", {
                                              className: "w-14 border border-gray-300 rounded px-2 py-1 text-xs",
                                              max: String(NpsRepresentationConfig$ReactHooksTemplate.endValue(scaleString)),
                                              min: String(NpsRepresentationConfig$ReactHooksTemplate.startValue(scaleString)),
                                              type: "number",
                                              value: rangeInputDisplayValue("passive", "max"),
                                              onBlur: (function (param) {
                                                  Curry._1(setPendingRangeEdit, (function (param) {
                                                          
                                                        }));
                                                }),
                                              onChange: (function (e) {
                                                  handleRangeInputChange("passive", "max", e.target.value);
                                                })
                                            }),
                                        JsxRuntime.jsx("select", {
                                              children: $$Array.of_list(Belt_List.map(NpsRepresentationConfig$ReactHooksTemplate.colorOptions, (function (param) {
                                                          var val_ = param[0];
                                                          return JsxRuntime.jsx("option", {
                                                                      children: param[1],
                                                                      value: val_
                                                                    }, val_);
                                                        }))),
                                              className: "border border-gray-300 rounded px-2 py-1 text-xs",
                                              value: categoryColors.passive,
                                              onChange: (function (e) {
                                                  updateCategoryColor("passive", e.target.value);
                                                })
                                            })
                                      ],
                                      className: "sb-nps-range-row"
                                    }),
                                JsxRuntime.jsxs("div", {
                                      children: [
                                        JsxRuntime.jsx("span", {
                                              children: "Promoter",
                                              className: "sb-nps-range-label font-medium"
                                            }),
                                        JsxRuntime.jsx("input", {
                                              className: "w-14 border border-gray-300 rounded px-2 py-1 text-xs",
                                              max: String(NpsRepresentationConfig$ReactHooksTemplate.endValue(scaleString)),
                                              min: String(NpsRepresentationConfig$ReactHooksTemplate.startValue(scaleString)),
                                              type: "number",
                                              value: rangeInputDisplayValue("promoter", "min"),
                                              onBlur: (function (param) {
                                                  Curry._1(setPendingRangeEdit, (function (param) {
                                                          
                                                        }));
                                                }),
                                              onChange: (function (e) {
                                                  handleRangeInputChange("promoter", "min", e.target.value);
                                                })
                                            }),
                                        JsxRuntime.jsx("span", {
                                              children: "to"
                                            }),
                                        JsxRuntime.jsx("input", {
                                              className: "w-14 border border-gray-300 rounded px-2 py-1 text-xs",
                                              max: String(NpsRepresentationConfig$ReactHooksTemplate.endValue(scaleString)),
                                              min: String(NpsRepresentationConfig$ReactHooksTemplate.startValue(scaleString)),
                                              type: "number",
                                              value: rangeInputDisplayValue("promoter", "max"),
                                              onBlur: (function (param) {
                                                  Curry._1(setPendingRangeEdit, (function (param) {
                                                          
                                                        }));
                                                }),
                                              onChange: (function (e) {
                                                  handleRangeInputChange("promoter", "max", e.target.value);
                                                })
                                            }),
                                        JsxRuntime.jsx("select", {
                                              children: $$Array.of_list(Belt_List.map(NpsRepresentationConfig$ReactHooksTemplate.colorOptions, (function (param) {
                                                          var val_ = param[0];
                                                          return JsxRuntime.jsx("option", {
                                                                      children: param[1],
                                                                      value: val_
                                                                    }, val_);
                                                        }))),
                                              className: "border border-gray-300 rounded px-2 py-1 text-xs",
                                              value: categoryColors.promoter,
                                              onChange: (function (e) {
                                                  updateCategoryColor("promoter", e.target.value);
                                                })
                                            })
                                      ],
                                      className: "sb-nps-range-row"
                                    })
                              ],
                              className: "space-y-2 text-sm sb-nps-ranges"
                            })
                      ],
                      className: "mb-4 pb-4 border-b border-gray-300 sb-editor-subsection"
                    }),
                JsxRuntime.jsxs("div", {
                      children: [
                        JsxRuntime.jsx("div", {
                              children: "Visual Representation",
                              className: "text-darkcharcoal text-sm mb-2 font-medium"
                            }),
                        JsxRuntime.jsx("select", {
                              children: $$Array.of_list(Belt_List.map(NpsRepresentationConfig$ReactHooksTemplate.visualTypeOptions, (function (param) {
                                          var val_ = param[0];
                                          return JsxRuntime.jsx("option", {
                                                      children: param[1],
                                                      value: val_
                                                    }, val_);
                                        }))),
                              className: "w-full border border-gray-300 rounded px-3 py-2 text-sm",
                              value: currentComponentType,
                              onChange: (function (e) {
                                  var newType = e.target.value;
                                  var updatedNps = Nps$ReactHooksTemplate.setComponentType(nps, newType);
                                  var tmp;
                                  if (newType === "custom") {
                                    var defaultConfig = NpsRepresentationConfig$ReactHooksTemplate.buildCustomConfig("number", customItems);
                                    tmp = Nps$ReactHooksTemplate.setConfiguration(updatedNps, NpsRepresentationConfig$ReactHooksTemplate.mergeCategoryIntoConfig(defaultConfig, categoryRanges, categoryColors));
                                  } else {
                                    tmp = Nps$ReactHooksTemplate.setConfiguration(updatedNps, NpsRepresentationConfig$ReactHooksTemplate.mergeCategoryIntoConfig(undefined, categoryRanges, categoryColors));
                                  }
                                  Curry._1(onNpsChange, tmp);
                                })
                            }),
                        currentComponentType === "custom" ? JsxRuntime.jsxs("div", {
                                children: [
                                  JsxRuntime.jsxs("div", {
                                        children: [
                                          JsxRuntime.jsx("label", {
                                                children: "Visual type",
                                                className: "block text-sm text-darkcharcoal mb-1"
                                              }),
                                          JsxRuntime.jsx("select", {
                                                children: $$Array.of_list(Belt_List.map(NpsRepresentationConfig$ReactHooksTemplate.customVisualTypeOptions, (function (param) {
                                                            var val_ = param[0];
                                                            return JsxRuntime.jsx("option", {
                                                                        children: param[1],
                                                                        value: val_
                                                                      }, val_);
                                                          }))),
                                                className: "w-full border border-gray-300 rounded px-3 py-2 text-sm",
                                                value: currentVisualType,
                                                onChange: (function (e) {
                                                    var newVisualType = e.target.value;
                                                    var newItems = NpsRepresentationConfig$ReactHooksTemplate.defaultItemsForScaleAndType(scaleString, newVisualType);
                                                    Curry._1(setCustomItems, (function (param) {
                                                            return newItems;
                                                          }));
                                                    var config = NpsRepresentationConfig$ReactHooksTemplate.buildCustomConfig(newVisualType, newItems);
                                                    Curry._1(onNpsChange, Nps$ReactHooksTemplate.setConfiguration(nps, NpsRepresentationConfig$ReactHooksTemplate.mergeCategoryIntoConfig(config, categoryRanges, categoryColors)));
                                                  })
                                              })
                                        ]
                                      }),
                                  currentVisualType === "emoji" && customItems.length !== 0 ? JsxRuntime.jsxs("div", {
                                          children: [
                                            JsxRuntime.jsx("label", {
                                                  children: "Per-step: emoji or text",
                                                  className: "block text-sm text-darkcharcoal mb-2"
                                                }),
                                            JsxRuntime.jsx("div", {
                                                  children: JsxRuntime.jsxs("table", {
                                                        children: [
                                                          JsxRuntime.jsx("thead", {
                                                                children: JsxRuntime.jsxs("tr", {
                                                                      children: [
                                                                        JsxRuntime.jsx("th", {
                                                                              children: "Value",
                                                                              className: "text-left py-1 pr-2"
                                                                            }),
                                                                        JsxRuntime.jsx("th", {
                                                                              children: "Content (emoji/text)",
                                                                              className: "text-left py-1"
                                                                            })
                                                                      ],
                                                                      className: "border-b border-gray-200"
                                                                    })
                                                              }),
                                                          JsxRuntime.jsx("tbody", {
                                                                children: Belt_Array.mapWithIndex(customItems, (function (i, it) {
                                                                        return JsxRuntime.jsxs("tr", {
                                                                                    children: [
                                                                                      JsxRuntime.jsx("td", {
                                                                                            children: String(it.value),
                                                                                            className: "py-1 pr-2"
                                                                                          }),
                                                                                      JsxRuntime.jsx("td", {
                                                                                            children: JsxRuntime.jsx("input", {
                                                                                                  className: "w-full border border-gray-300 rounded px-2 py-1 text-xs",
                                                                                                  placeholder: "e.g. 😞 or Sad",
                                                                                                  type: "text",
                                                                                                  value: it.content,
                                                                                                  onChange: (function (e) {
                                                                                                      updateCustomItem(i, "content", e.target.value);
                                                                                                    })
                                                                                                }),
                                                                                            className: "py-1"
                                                                                          })
                                                                                    ],
                                                                                    className: "border-b border-gray-100"
                                                                                  }, String(i));
                                                                      }))
                                                              })
                                                        ],
                                                        className: "w-full text-sm"
                                                      }),
                                                  className: "overflow-x-auto max-h-48 overflow-y-auto"
                                                })
                                          ],
                                          className: "border border-gray-200 rounded p-2"
                                        }) : null,
                                  currentVisualType === "svg" && customItems.length !== 0 ? JsxRuntime.jsxs("div", {
                                          children: [
                                            JsxRuntime.jsx("label", {
                                                  children: "Per-step: inline SVG",
                                                  className: "block text-sm text-darkcharcoal mb-2"
                                                }),
                                            JsxRuntime.jsx("div", {
                                                  children: JsxRuntime.jsxs("table", {
                                                        children: [
                                                          JsxRuntime.jsx("thead", {
                                                                children: JsxRuntime.jsxs("tr", {
                                                                      children: [
                                                                        JsxRuntime.jsx("th", {
                                                                              children: "Value",
                                                                              className: "text-left py-1 pr-2"
                                                                            }),
                                                                        JsxRuntime.jsx("th", {
                                                                              children: "Inline SVG",
                                                                              className: "text-left py-1"
                                                                            })
                                                                      ],
                                                                      className: "border-b border-gray-200"
                                                                    })
                                                              }),
                                                          JsxRuntime.jsx("tbody", {
                                                                children: Belt_Array.mapWithIndex(customItems, (function (i, it) {
                                                                        return JsxRuntime.jsxs("tr", {
                                                                                    children: [
                                                                                      JsxRuntime.jsx("td", {
                                                                                            children: String(it.value),
                                                                                            className: "py-1 pr-2"
                                                                                          }),
                                                                                      JsxRuntime.jsx("td", {
                                                                                            children: JsxRuntime.jsx("input", {
                                                                                                  className: "w-full border border-gray-300 rounded px-2 py-1 text-xs font-mono",
                                                                                                  placeholder: "<svg>...</svg>",
                                                                                                  type: "text",
                                                                                                  value: it.inline,
                                                                                                  onChange: (function (e) {
                                                                                                      updateCustomItem(i, "inline", e.target.value);
                                                                                                    })
                                                                                                }),
                                                                                            className: "py-1"
                                                                                          })
                                                                                    ],
                                                                                    className: "border-b border-gray-100"
                                                                                  }, String(i));
                                                                      }))
                                                              })
                                                        ],
                                                        className: "w-full text-sm"
                                                      }),
                                                  className: "overflow-x-auto max-h-48 overflow-y-auto"
                                                })
                                          ],
                                          className: "border border-gray-200 rounded p-2"
                                        }) : null,
                                  currentVisualType === "number" ? JsxRuntime.jsx("p", {
                                          children: "Uses default colored number boxes (red / yellow / green by score). No extra options.",
                                          className: "text-sm text-spanishgray"
                                        }) : null
                                ],
                                className: "mt-3 space-y-3"
                              }) : null
                      ],
                      className: "mb-4 pb-4 border-b border-gray-300"
                    })
              ]
            });
}

var maxCount = 24;

var make = NpsEditor;

exports.maxCount = maxCount;
exports.getCurrentComponentType = getCurrentComponentType;
exports.decodeConfigItems = decodeConfigItems;
exports.getVisualType = getVisualType;
exports.normalizeConfiguration = normalizeConfiguration;
exports.make = make;
/* react Not a pure module */
